export const CREATE_PROJECT_WIZARD_TAG = 'create-project-wizard';

export const CREATE_PROJECT_WIZARD_STEPS = [
  'basics',
  'conceptGroupsAndAttributes',
  'datasetImport',
  'splittingAndDriftCheck',
  'allocation',
  'reviewAndCreate',
];

export const CREATE_PROJ_SUCCESS_MODAL_TIMEOUT = 5;

export const DATA_IMPORT_MODES = ['file-upload', 's3-path'] as const;
